export default __webpack_public_path__ + "static/media/white-load.f6cca4d5.gif";